import React from 'react'

import Section from '../../../../../../components/Section'
import { Structure } from '../../../../Org/Structure/types'

type Props = {
    theme: string
    contractGuid: string
    structShortName: string | null
    structShortGuid: string | null
    onStructChange: (value: {
        structName: string | null
        structGuid: string | null
    }) => void
    typeObjectContract: string | null
    onTypeObjectContractChange: (value: string | null) => void
    structList: Structure[]
}

const ContractCardBaseInfo: React.FC<Props> = (props) => {
    const updateContract = async (updatedField: Record<string, any>) => {
        try {
            const response = await fetch(
                process.env.REACT_APP_API_URL +
                    '/api/backend/v1/contract/' +
                    encodeURIComponent(props.contractGuid),
                {
                    method: 'PUT',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(updatedField),
                }
            )
            if (!response.ok) {
                throw new Error('Ошибка обновления данных в базе')
            }
        } catch (error) {
            console.error(error)
        }
    }

    const handleStructChange = (value: string) => {
        if (value === '') {
            console.log(value)
            props.onStructChange({
                structGuid: null,
                structName: null,
            })
            updateContract({
                struct_guid: null,
                struct_name: null,
            })
        }
        const selectedStruct = props.structList.find((s) => s.guid === value)
        if (selectedStruct) {
            props.onStructChange({
                structGuid: selectedStruct.guid,
                structName: selectedStruct.struct_name,
            })
            updateContract({
                struct_guid: selectedStruct.guid,
                struct_name: selectedStruct.struct_name,
            })
        }
    }

    const handleTypeObjectChange = (value: string) => {
        if (value == '') {
            props.onTypeObjectContractChange(null)
            updateContract({ type_object_contract: null })
        } else {
            props.onTypeObjectContractChange(value)
            updateContract({ type_object_contract: value })
        }
    }

    return (
        <Section title="Общая информация">
            <div className="flex flex-col w-full gap-x-5 mt-2">
                <div className="flex flex-col min-w-[200px]">
                    <span className="mb-1 text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Подразделение
                    </span>
                    <select
                        className="form-select"
                        value={props.structShortGuid ?? ''} // '' когда null/undefined
                        onChange={(e) => handleStructChange(e.target.value)}
                    >
                        {/* плейсхолдер не disabled */}
                        <option value="">Выбрать</option>

                        {props.structList.length > 0 ? (
                            props.structList.map((struct) => (
                                <option key={struct.guid} value={struct.guid}>
                                    {struct.struct_name}
                                </option>
                            ))
                        ) : (
                            <option value="" disabled>
                                Данные отсутствуют
                            </option>
                        )}
                    </select>
                </div>
                <div className="flex flex-col min-w-[200px]">
                    <span className="mt-2 mb-1 text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Тип объекта закупки
                    </span>
                    <select
                        className="form-select "
                        value={props.typeObjectContract ?? ''}
                        onChange={(e) => handleTypeObjectChange(e.target.value)}
                    >
                        <option value="">Выбрать</option>
                        <option value="G">Товар</option>
                        <option value="W">Работа</option>
                        <option value="S">Услуга</option>
                    </select>
                </div>
            </div>
        </Section>
    )
}

export default ContractCardBaseInfo
